var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfinityAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 133,
    height: 241.852,
    viewBox: "0 0 133 241.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.136,
    y1: 0.425,
    x2: 1.129,
    y2: 0.63,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#7fbfe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#79bbde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#6bb1d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#53a0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#3189c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2581c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.067,
    y1: 0.425,
    x2: 1.074,
    y2: 0.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1.766,
    y1: 0.12,
    x2: 0.688,
    y2: 0.518,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2581c4",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    "data-name": "Group 503",
    transform: "translate(4151 5433.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502",
    transform: "translate(-4344 -5697)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 66.5,
    cy: 6.5,
    rx: 66.5,
    ry: 6.5,
    transform: "translate(193 492)",
    fill: "#707070",
    opacity: 0.18
  })), /*#__PURE__*/React.createElement("g", {
    id: "Infinity_5",
    "data-name": "Infinity 5",
    transform: "translate(-4300.232 -5467.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M277.529,345.805q0,1.734-.1,3.459a57.286,57.286,0,0,1-.912,7.219,59.189,59.189,0,0,1-3.1,10.64,61.35,61.35,0,0,1-4.122,8.478,62.57,62.57,0,0,1-20.848,21.544q-2.411,1.509-4.982,2.787a58.748,58.748,0,0,1-43.445,3.586c-.409-.127-.818-.258-1.222-.395q-2.066-.684-4.051-1.518c-.414-.174-.822-.348-1.227-.531-.066-.028-.132-.061-.2-.089a61.736,61.736,0,0,1-24.138-19.631c-.193-.263-.385-.526-.578-.794a63.671,63.671,0,0,1-4.394-7.05c-.16-.291-.315-.583-.465-.879a62.693,62.693,0,0,1-3.6-8.413,58.963,58.963,0,0,1-2.007-7.275,56.348,56.348,0,0,1-1.2-11.138,53.207,53.207,0,0,1,1.372-12.389A61.925,61.925,0,0,1,169.918,309.6v0a76.991,76.991,0,0,1,6.429-7.294,68.369,68.369,0,0,1,9-7.679l.056-.014c.155-.047.31-.094.465-.136a133.049,133.049,0,0,1,50.325-4.5q1.628.162,3.163.357s.009,0,.014,0c.367.042.733.089,1.09.136.056.009.108.014.164.023q1.389.663,2.735,1.382c.155.08.306.164.456.249a67.538,67.538,0,0,1,16.064,12.111v0a65.013,65.013,0,0,1,4.479,5.066c.785.987,1.542,2,2.261,3.027q.726,1.022,1.4,2.073a60.807,60.807,0,0,1,6.067,12.205,56.26,56.26,0,0,1,1.927,6.439,55.536,55.536,0,0,1,1.509,12.76Z",
    transform: "translate(0 -135.358)",
    fill: "#e9f0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M273.669,292.53a1.426,1.426,0,0,1-.277.893,8.105,8.105,0,0,1-3.619,2.34l-.033.014a45.466,45.466,0,0,1-6.528,1.965l-.54.127a126.388,126.388,0,0,1-18.766,2.533c-3,.2-5.912.305-8.662.324h0c-9.052.07-16.383-.78-19.8-2.265-.15-.066-.291-.136-.428-.2a3,3,0,0,1-1.565-1.391,1.229,1.229,0,0,1-.085-.362,1.4,1.4,0,0,1,.019-.305,1.285,1.285,0,0,1,.1-.305,2.582,2.582,0,0,1,.724-.912c.089-.075.183-.15.277-.23a.143.143,0,0,0,.033-.023,9.6,9.6,0,0,1,1.264-.775c4.549-2.369,15.039-4.507,27.348-5.32,10.006-.663,18.94-.3,24.519.808a.017.017,0,0,1,.014,0c.573.113,1.109.235,1.607.362,0,0,.009,0,.014,0,2.242.578,3.718,1.307,4.206,2.157a1.3,1.3,0,0,1,.179.559Z",
    transform: "translate(-29.908 -134.843)",
    fill: "#aeb7c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M182.6,339.727a110.885,110.885,0,0,0-11.349,24.578,19.941,19.941,0,0,1-11.4-7.972,61.925,61.925,0,0,1,11.608-23.819,17.4,17.4,0,0,0,11.142,7.212Z",
    transform: "translate(-1.546 -158.276)",
    fill: "#aeb7c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M378.763,343.478a19.874,19.874,0,0,1-10.3,8.972,110.494,110.494,0,0,0-14.043-23.142,17.547,17.547,0,0,0,6.194-3.389,17.345,17.345,0,0,0,3.943-4.813,65,65,0,0,1,4.479,5.066c.785.987,1.542,2,2.261,3.027q.726,1.022,1.4,2.073a60.805,60.805,0,0,1,6.067,12.205Z",
    transform: "translate(-104.67 -152.229)",
    fill: "#aeb7c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_526",
    "data-name": "Rectangle 526",
    width: 19.738,
    height: 14.098,
    rx: 6.711,
    transform: "translate(205.087 180.485) rotate(-3.806)",
    fill: "#2eb3bd",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M255.923,135.045a6.346,6.346,0,0,1-2.688,1.875,78.576,78.576,0,0,1-30.8,7.736q-.966.042-1.9.056a78.258,78.258,0,0,1-19.734-2.2c-.935-.23-1.824-.461-2.655-.7a6.312,6.312,0,0,1-2.933-1.354A6.189,6.189,0,0,1,193,136.225l-7.98-89.352a6.478,6.478,0,0,1,1.429-4.563,6.265,6.265,0,0,1,1.612-1.368,6.416,6.416,0,0,1,1.687-.7h0a104.783,104.783,0,0,1,54.029-4.775c.056,0,.122.014.193.023a6.337,6.337,0,0,1,2.152.7,5.78,5.78,0,0,1,1.034.7,6.51,6.51,0,0,1,2.218,4.239l7.976,89.352A6.547,6.547,0,0,1,255.923,135.045Z",
    transform: "translate(-14.875 -0.001)",
    fill: "#e9f0fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_527",
    "data-name": "Rectangle 527",
    width: 4.964,
    height: 43.621,
    transform: "translate(213.486 194.042) rotate(-3.562)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M278.783,416.917a57.286,57.286,0,0,1-.912,7.219,98.378,98.378,0,0,1-14.927,9.635c-.042.023-.085.042-.127.066a102.746,102.746,0,0,1-48.939,11.284,116.535,116.535,0,0,1-42.81-8.8c-3.68-1.509-6.89-3.05-9.564-4.451A58.963,58.963,0,0,1,159.5,424.6c1.612.893,3.468,1.871,5.546,2.881a117.048,117.048,0,0,0,42.632,11.59c3.492.23,6.782.273,9.8.207,1.748-.042,3.4-.122,4.958-.23a96.174,96.174,0,0,0,13.394-1.786,103.977,103.977,0,0,0,28.03-10.509c2.693-1.471,5.466-3.135,8.276-5.01,2.608-1.739,4.836-3.4,6.65-4.822Z",
    transform: "translate(-1.358 -203.01)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    d: "M206.994,498.12q-2.066-.684-4.051-1.518c-.414-.174-.822-.348-1.227-.531a56.075,56.075,0,0,0,.362-8.088,5.843,5.843,0,0,0-1.184-3.689,5.717,5.717,0,0,0-2.326-1.579,5.093,5.093,0,0,0-1.175-.23,108,108,0,0,1-20.012-6.133c-.193-.263-.385-.526-.578-.794a63.663,63.663,0,0,1-4.394-7.05c.141.07.291.146.437.216a120.655,120.655,0,0,0,28.669,9.686,6.353,6.353,0,0,1,1.311.258,6.96,6.96,0,0,1,4.963,6.669,56.984,56.984,0,0,1-.794,12.783Z",
    transform: "translate(-8.201 -230.354)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M368.361,454.921a61.352,61.352,0,0,1-4.122,8.478,108.193,108.193,0,0,1-18.16,8.168,4.974,4.974,0,0,0-1.137.385,5.767,5.767,0,0,0-2.105,1.861,5.864,5.864,0,0,0-.691,3.816,56.666,56.666,0,0,0,1.245,7.313q-2.411,1.509-4.982,2.787a56.765,56.765,0,0,1-2.27-11.984,6.963,6.963,0,0,1,4.056-7.257,6.387,6.387,0,0,1,1.269-.423,120.838,120.838,0,0,0,26.9-13.145Z",
    transform: "translate(-94.95 -223.153)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M256.881,120.127c-1.4.62-2.669,1.25-3.812,1.856a5.128,5.128,0,0,0-2.246,1.762,6.49,6.49,0,0,0-1.133,2.641,7.242,7.242,0,0,0-.108,1.871l.211,3.182a55.574,55.574,0,0,1-31.456,4.756,57.689,57.689,0,0,1-6.735-1.358l-.583-3.718a7.248,7.248,0,0,0-.522-1.8,6.484,6.484,0,0,0-1.687-2.326,5.062,5.062,0,0,0-2.58-1.222c-1.09-.3-2.284-.592-3.572-.86L195.1,40.245h0a104.721,104.721,0,0,1,49.912-5.409c1.457.193,2.829.409,4.117.634.056,0,.122.014.193.023l7.557,84.634Z",
    transform: "translate(-20.227)",
    fill: "#353f44"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_528",
    "data-name": "Rectangle 528",
    width: 16.95,
    height: 24.11,
    rx: 8.475,
    transform: "translate(185.033 67.937) rotate(-4.764)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_529",
    "data-name": "Rectangle 529",
    width: 16.95,
    height: 24.11,
    rx: 8.475,
    transform: "translate(207.6 66.057) rotate(-4.764)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M266.107,289.452a43.684,43.684,0,0,0-21.252,6.895,23.817,23.817,0,0,1-9.611,4.38h0a24.93,24.93,0,0,1-6.472.216c-4.117-.216-10.175-1.048-13.324-2.481-.15-.066-.291-.136-.428-.2a3.206,3.206,0,0,1-1.565-1.391,1.228,1.228,0,0,1-.085-.362,1.4,1.4,0,0,1,.019-.305,1.526,1.526,0,0,1,.1-.305,2.856,2.856,0,0,1,.724-.912c.089-.075.183-.15.277-.23a.143.143,0,0,0,.033-.023c.254-.207.522-.423.8-.639.155-.047.31-.094.465-.136,4.549-2.369,15.039-4.507,27.348-5.32,10.006-.663,18.94-.3,24.519.808-.493-.014-1.006-.014-1.542.009Z",
    transform: "translate(-29.908 -134.843)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M356.9,348.732q0,1.734-.1,3.459a57.286,57.286,0,0,1-.912,7.219,59.192,59.192,0,0,1-3.1,10.64,61.351,61.351,0,0,1-4.122,8.478,62.57,62.57,0,0,1-20.848,21.544q-2.411,1.509-4.982,2.787a58.52,58.52,0,0,1-14.6,5.019,84.414,84.414,0,0,0,11.148-7.83c6.641-5.508,14.823-12.3,19.424-24.227a46.5,46.5,0,0,0,2.026-6.711,48.828,48.828,0,0,0,1.039-7.087,70.049,70.049,0,0,0,.07-7.924,65.2,65.2,0,0,0-7.731-27.785c-2.533-4.529-7.075-12.434-16.395-18.588a46.467,46.467,0,0,0-11.131-5.37c.979-.176,8.878-1.6,10.193-2.15a19.086,19.086,0,0,0,2.326-.987l.033-.014a20.164,20.164,0,0,0,3.619-2.34,3.311,3.311,0,0,0,.1-1.452,1.9,1.9,0,0,0-.216-.616,67.73,67.73,0,0,1,16.52,12.36v0a65,65,0,0,1,4.479,5.066c.785.987,1.542,2,2.261,3.027q.726,1.022,1.4,2.073a60.807,60.807,0,0,1,6.067,12.205,56.267,56.267,0,0,1,1.927,6.439,55.535,55.535,0,0,1,1.509,12.76Z",
    transform: "translate(-79.368 -138.284)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M296,137.632a6.346,6.346,0,0,1-2.688,1.875,78.576,78.576,0,0,1-30.8,7.736q-.966.042-1.9.056c14.175-3.492,24.448-6.923,28.218-9.216A9.752,9.752,0,0,0,293,133.7a9.484,9.484,0,0,0,.418-5.851q-3-35.819-5.847-71.644-.7-8.713-1.377-17.427a5.781,5.781,0,0,1,1.034.7,6.51,6.51,0,0,1,2.218,4.239l7.976,89.352A6.547,6.547,0,0,1,296,137.632Z",
    transform: "translate(-54.949 -2.588)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M283.091,121.189c-1.4.62-2.669,1.25-3.812,1.856a5.128,5.128,0,0,0-2.247,1.762,6.49,6.49,0,0,0-1.133,2.641,7.242,7.242,0,0,0-.108,1.871L276,132.5a55.574,55.574,0,0,1-31.456,4.756,119.759,119.759,0,0,0,21.638-7.905,20.648,20.648,0,0,0,3.13-1.668c9.851-6.909,7.524-24.185,5.015-51.8-.841-9.268-2-22.954-3.107-39.986,1.457.193,2.829.409,4.117.634.056,0,.122.014.193.023l7.557,84.634Z",
    transform: "translate(-46.436 -1.062)",
    fill: "#15192f",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M204.723,107.393q-2.4-30.079-4.8-60.157a72.1,72.1,0,0,1,7.1-2.506,73.824,73.824,0,0,1,23.6-2.924c-3.143.867-7.777,2.243-13.333,4.271-5.081,1.854-6.092,2.486-6.752,2.978-5.648,4.215-5.612,13.2-5.607,18.653.012,12.163-.11,24.939-.209,39.687Z",
    transform: "translate(-22.782 -4.166)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M200.8,150.459c-.935-.23-1.824-.461-2.655-.7a6.312,6.312,0,0,1-2.933-1.354A6.189,6.189,0,0,1,193,144.17l-7.98-89.352a6.478,6.478,0,0,1,1.429-4.563,6.265,6.265,0,0,1,1.612-1.368c-.244,1.443-.479,3.144-.644,5.052a62.286,62.286,0,0,0,0,10.654c1.429,17.511,2.143,26.272,3.135,37.805,1.057,12.281,3.52,24.448,3.967,36.766a13.672,13.672,0,0,0,.837,4.385A15.364,15.364,0,0,0,200.8,150.459Z",
    transform: "translate(-14.875 -7.947)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M193.318,415.673a61.736,61.736,0,0,1-24.138-19.631c-.193-.263-.385-.526-.578-.794a63.671,63.671,0,0,1-4.394-7.05c-.16-.291-.315-.583-.465-.879a62.693,62.693,0,0,1-3.6-8.413,58.963,58.963,0,0,1-2.007-7.275,56.348,56.348,0,0,1-1.2-11.138,53.207,53.207,0,0,1,1.372-12.389,61.925,61.925,0,0,1,11.608-23.819v0a76.991,76.991,0,0,1,6.429-7.294c-1.053,1.852-2.2,3.948-3.389,6.26-3.6,6.989-7.651,14.865-9.818,23.4a68.152,68.152,0,0,0-.207,29.867c4.916,20.735,21.074,33.378,30.384,39.163Z",
    transform: "translate(0 -150.045)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M322.136,294.387a3.81,3.81,0,0,1-1.9,2.265.1.1,0,0,0-.028.019,28.16,28.16,0,0,1-4.328,1.95,33.946,33.946,0,0,1-11.035,2.289h-.038a65.685,65.685,0,0,0,6.476-2.289c4.611-1.9,6.932-2.886,7.52-4.6a3.749,3.749,0,0,0,.085-2.026c-.014-.061-.028-.127-.047-.193.056.009.108.014.164.023q1.389.663,2.735,1.382c.155.08.305.164.456.249A2.887,2.887,0,0,1,322.136,294.387Z",
    transform: "translate(-78.376 -136.699)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M268.632,359.445a3.028,3.028,0,0,1-2.66-3.209,3.02,3.02,0,0,1,1.093-2.148,2.948,2.948,0,0,1,1.568-.574,4.78,4.78,0,0,1,3.474,1.326c.415.368.957.979,1.085,1.123.392.442.525.633.748.9a5.474,5.474,0,0,0,2.228,1.813,3.257,3.257,0,0,0,2.373.015,3.186,3.186,0,0,0,1.674-1.707,2.954,2.954,0,0,0,.141-2.068,2.824,2.824,0,0,0-.665-1.073,3.123,3.123,0,0,0-1.223-.792,3.943,3.943,0,0,0-3.391.755,7.043,7.043,0,0,0-.888.793l-.085.094a7.873,7.873,0,0,0-.913,1.274c-.309.511-.355.678-.547,1.016a4.985,4.985,0,0,1-1.941,2.032,3.368,3.368,0,0,1-2.072.434Z",
    transform: "translate(-57.789 -169.099)",
    fill: "none",
    stroke: "#139093",
    strokeWidth: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinityAccount);
export default __webpack_public_path__ + "static/media/infinity-account.c1c1ac97865ee6dffdc3f3b163464565.svg";
export { ForwardRef as ReactComponent };